import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {
    MFA_OTP_CODE_VERIFY_URL,
    MFA_SETUP_CODE_VERIFY_URL
} from '../config/url-config'
import {
    ERR_MSG,
    SESS_EXPIRED_TEXT,
    SUCCESS_CODES,
    MFA_VER_ERR_100,
    MFA_VER_ERR_101,
    MFA_OTP_WRONG_ERR,
    MFA_VER_ERR_102,
    MFA_VER_ERR_103,
    MFA_OTP_TRY_AGAIN_ERR,
    MFA_VER_ERR_104,
    MFA_VER_ERR_105, MFA_VER_ERR_106, MFA_VER_ERR_107,
} from "../constants/constants";
import {loadSessionExpired} from "../store/action";
import {store} from "../store/store";
import {extractStatusCode} from "../helper/responsehelper";

export const mfaVerifyTokenResponseStatus = {
    [MFA_VER_ERR_100]:MFA_OTP_WRONG_ERR,
    [MFA_VER_ERR_101]:ERR_MSG,
    [MFA_VER_ERR_102]:SESS_EXPIRED_TEXT,
    [MFA_VER_ERR_103]:ERR_MSG,
    [MFA_VER_ERR_104]:MFA_OTP_TRY_AGAIN_ERR,
    [MFA_VER_ERR_105]:SESS_EXPIRED_TEXT,
    [MFA_VER_ERR_106]:ERR_MSG,
    [MFA_VER_ERR_107]:SESS_EXPIRED_TEXT,
    "UNK-ERR-102": ERR_MSG,
};
const constructMFAVerifyTokenRequest = (session,otpCode,userName)=>(
    {
        session:session,
        otpCode:otpCode,
        userName:userName
    }
)
export const mfaVerifyTokenService = (session,otpCode,userName)=>{
    const codeVerifyRequest = constructMFAVerifyTokenRequest(session,otpCode,userName)

    return new Promise((resolve,reject)=>{
        axiosInstance
            .post(MFA_OTP_CODE_VERIFY_URL(),codeVerifyRequest)
            .then((response) => {
                let statusCode =extractStatusCode(response);
                if(SUCCESS_CODES.MFA_VERIFY_TOKEN.includes(statusCode)){
                    resolve(response)
                }else{
                    let errText = mfaVerifyTokenResponseStatus[statusCode]
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                reject(ERR_MSG)
            });
    })
}